import { useNavigate } from '@tanstack/react-router';
import { Compass } from 'lucide-react';
import { SystemMessageLayout } from '../ui/SystemMessageLayout';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <SystemMessageLayout
      statusCode={404}
      icon={<Compass className="w-12 h-12" strokeWidth={1.5} />}
      title="Page Not Found"
      description="The page you are looking for doesn't exist or has been moved. Check the URL or return to your dashboard."
      action={{
        label: 'Return to Dashboard',
        onClick: () => navigate({ to: '/' }),
      }}
    />
  );
}
